import { format } from "date-fns";

// Shared helpers + offline browsing mocks for the viewings feature.

export const API_BASE = `${process.env.REACT_APP_BACKEND_URL || ""}/api`;

export function icsUrl(viewingId) {
  return `${API_BASE}/viewings/${viewingId}/ics`;
}

export function slotLabel(iso) {
  try {
    return format(new Date(iso), "EEE MMM d, h:mm a");
  } catch {
    return iso;
  }
}

function daysFromNow(days, hour) {
  const d = new Date();
  d.setDate(d.getDate() + days);
  d.setHours(hour, 0, 0, 0);
  return d.toISOString();
}

// Offline fallback so the viewing UI states stay browsable in demo mode.
export function mockViewings(matchId = "m1") {
  return [
    {
      id: "vw_demo_1",
      match_id: matchId,
      listing_id: "l1",
      slots: [daysFromNow(2, 17), daysFromNow(3, 12), daysFromNow(4, 18)],
      accepted_slot: null,
      status: "proposed",
      listing_title: "Sunny 1BR near High Park",
      demo: true,
    },
    {
      id: "vw_demo_2",
      match_id: "m3",
      listing_id: "l8",
      slots: [daysFromNow(1, 18)],
      accepted_slot: daysFromNow(1, 18),
      status: "confirmed",
      listing_title: "Plateau walk up with balcony",
      demo: true,
    },
  ];
}
